export enum PolygonType {
  ZONE,
  AREA,
}
